import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import { DATE } from "helpers/shapes"
import CompareChart from "components/charts/compare"
import CompareTable from "components/compare-table"
import CompareSelect from "components/material/compare-select"
import { oneDecimalPercentageFormatter, smallPercentageFormatter } from "helpers/formatters/numbers"
import { FACTOR_CATEGORIES_SHAPE } from "components/factor-categories/shapes"
import { DATA, DETAILS_ITEMS, DOWNLOAD_FILENAME, ITEMS, METRICS, SELECTED_METRIC, TABLE_DOWNLOAD_DATA } from "helpers/shapes/compare-screen"
import "./styles.scss"

export default function CompareRisk({
  status,
  data,
  startDate,
  endDate,
  selectedDate,
  setDate,
  metrics,
  selectedMetric,
  setMetric,
  items,
  chartItems,
  detailsItems,
  detailsData,
  saveMetricToStore,
  trackPanelTrigger,
  fixedItemNumber,
  hideGraph,
  factorCategories,
  fileName,
  tableDownloadData,
}) {
  const selectedView = "risk"
  return <Paper className="modules_compare-risk" square elevation={1}>
    <div className="wrapper">
      {!hideGraph && <CompareChart
        tooltipFormatter={smallPercentageFormatter}
        metricSelector={<CompareSelect
          options={metrics}
          selectedOption={selectedMetric}
          setSelected={setMetric}
          saveToStore={saveMetricToStore}
          storeName={selectedView}
        />}
        {...{
          status,
          tickFormat: oneDecimalPercentageFormatter,
          startDate,
          date: selectedDate,
          setDate,
          endDate,
          data,
          items: chartItems,
          fixedItemNumber,
          fileName,
          tableDownloadData,
          selectedView,
          percents: true,
        }}
      />}
      <CompareTable {...{
        items: detailsItems,
        data: detailsData,
        columns: items,
        trackPanelTrigger,
        fixedItemNumber,
        factorCategories,
      }}
      />
    </div>
  </Paper>
}

CompareRisk.propTypes = {
  status: PropTypes.string.isRequired,
  data: DATA.isRequired,
  startDate: DATE.isRequired,
  endDate: DATE.isRequired,
  selectedDate: DATE,
  setDate: PropTypes.func.isRequired,
  metrics: METRICS.isRequired,
  selectedMetric: SELECTED_METRIC.isRequired,
  setMetric: PropTypes.func.isRequired,
  items: ITEMS.isRequired,
  chartItems: ITEMS.isRequired,
  detailsItems: DETAILS_ITEMS.isRequired,
  detailsData: PropTypes.array.isRequired,
  saveMetricToStore: PropTypes.func.isRequired,
  trackPanelTrigger: PropTypes.func.isRequired,
  fixedItemNumber: PropTypes.bool,
  hideGraph: PropTypes.bool,
  factorCategories: FACTOR_CATEGORIES_SHAPE,
  fileName: DOWNLOAD_FILENAME,
  tableDownloadData: TABLE_DOWNLOAD_DATA,
}
